import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const authorizeAsset = (assetUuid) => request.post(`${API_BASE_URL}/blockchain/assets/${assetUuid}/authorize`)

export default authorizeAsset